/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'stellar_body/population': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10.52 8.389c1.051-.262 1.807-1.182 1.807-2.279 0-1.277-.977-2.357-2.398-2.357a2.356 2.356 0 00-2.281 2.356c0 1.098.756 2.018 1.773 2.279-1.344.387-2.363 1.865-2.363 4.029l-.029 3.254a7.943 7.943 0 005.94-.002l.002-3.252c0-2.163-1.065-3.642-2.451-4.028z"/>'
  }
})
